import * as React from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  Link as MUILink,
  TextField,
} from "@material-ui/core";
import { tl } from "../../utils";
import * as styles from "./styles.scss";
import { IAPIMessage } from "./types";
import { MUIDialog } from "../panel/MUI";

export const SetPhone = ({ setPhoneOuter, isCourse }: any) => {
  const history = useHistory();

  const [message, setMessage] = React.useState<IAPIMessage>(null);
  const [phone, setPhone] = React.useState<string>("");

  const onPhoneConfirm = React.useCallback(async () => {
    const data = new FormData();
    data.append("consumer", "at");
    data.append("phone", phone);

    const response = await fetch(`/login/doubleauth`, {
      method: "post",
      credentials: "include",
      body: data,
    });

    switch (response.status) {
      case 403:
        setMessage({
          message: tl(`Такой телефон не существует. Попробуйте снова.`),
          messageType: "error",
        });
        setPhone("");
      case 200:
        if (response.ok) {
          const result = await response.json();
          setPhoneOuter(phone);
        }
    }
  }, [phone]);

  return (
    <div className={`${styles.wrap} ${styles.wrapRestore} ${styles.taCenter}`}>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <Box className={styles.title} textAlign="center">
            {isCourse
              ? tl("Защита доступа к курсу")
              : tl("Защита доступа к аккаунту")}
          </Box>
        </Grid>
        <Grid item>
          {tl(
            "Введите свой номер телефона мы отправим на него СМС сообщение, чтобы подтвердить что это именно вы."
          )}
        </Grid>
        <Grid item>
          <TextField
            variant="outlined"
            color="primary"
            fullWidth
            placeholder={tl("Пример: +79261234567")}
            value={phone}
            onChange={(evt) => {
              setPhone(evt.target.value);
            }}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={onPhoneConfirm}
          >
            {tl("Сохранить")}
          </Button>
        </Grid>
      </Grid>
      {message ? (
        <MUIDialog
          open={!!message}
          onClose={() => {
            setMessage(null);
          }}
          maxWidth="xs"
          title={message.messageType === "error" ? tl("Ошибка!") : tl("Внимание!")}
          actions={[
            [],
            [
              {
                label: tl("Понятно"),
                btnProps: {
                  onClick: () => {
                    setMessage(null);
                  },
                },
              },
            ],
          ]}
        >
          {message.message}
        </MUIDialog>
      ) : null}
    </div>
  );
};
